module.exports = __webpack_public_path__ + "static/media/galeryCeilings4.6fe8d14f.jpg";